

































import Vue from "vue";
import Axios from "axios";
import CreateSequenceFormDetails from '@/components/sequence/CreateSequenceFormDetails.vue'
import CreateSequenceFormTimes from '@/components/sequence/CreateSequenceFormTimes.vue'
import CreateSequenceFormAdvanced from '@/components/sequence/CreateSequenceFormAdvanced.vue'
import Guid from "../../utils/Guid";

export default Vue.extend({  
  components: { CreateSequenceFormDetails, CreateSequenceFormTimes, CreateSequenceFormAdvanced },
  props: {
    viewId: {
      type: String
    },
    dates: {
      type: Array as () => Array<string>,
      default: () => {
        return [] as string[];
      },
    },
  },

  data() {
    return {
      errors: String[0],
      loading: false,
      position: 0,
      lastPageNumber: 2,
      firstPageNumber: 0,
    };
  },

  methods: {
    setDefaults()
    {
      this.$store.commit("sequence/setName", "");
      this.$store.commit("sequence/setEmail", "");
      this.$store.commit('sequence/setWidth', 1920)
      this.$store.commit('sequence/setHeight', 1080)
      this.$store.commit("sequence/setVideoDurationSecs", 30);
    },
    checkForm: function (e) {
      e.preventDefault();
    },
    next()
    {
      this.position = this.position + 1;
    },
    previous()
    {
      this.position = this.position - 1;
    },
    async submit() {
      const claims = this.$store.state.auth.token.claims;
      var data = this.$store.state.sequence;
      data.views = [this.viewId];
      data.clients = [];
      data.partners = [];
      data.uiId = Guid.newGuid();      
      data.crop = true;
      this.$store.commit("sequence/setUiId", data.uiId);
      if(claims.client) data.clients = [claims.client];
      if(claims.partner) data.partners = [claims.partner];      
      data.users = [this.$store.state.auth.user.uid];
      this.loading = true;
      window.console.log(JSON.stringify(data));
      try {
        const result = await Axios({
          data,
          headers: {
            authorization: `Bearer ${window.localStorage.getItem("idToken")}`,
          },
          method: "POST",
          url: process.env.VUE_APP_API_SEQUENCE
        });
        window.console.log(result);
        
        this.setDefaults();
        this.$emit('close')
      } catch (err) {
        window.console.error(err);
        alert("An unexpected error occurred.");
      }
      this.loading = false;
    },
    success(result) {
      alert(result.message);
      //this.$emit('success', {action: "create", data: {...result.data, _id: result.id}, id: result.id, resource: this.resource})
    },
  },

  created() {
    this.setDefaults();
      this.$store.commit("sequence/setUiId", "");
  },
});
